import { DropDownModel } from "./dropDown";
import { SimpleAdditionalInsuranceModel } from "./additionalInsurances";

export interface GravestoneModel extends SimpleAdditionalInsuranceModel {
    insuranceSum: GravestoneInsuranceSumId;
}

export enum GravestoneInsuranceSumId {
    fiveThousands = "SUM_5000",
    tenThousands = "SUM_10000",
    fifteenThousands = "SUM_15000",
    twentyFiveThousands = "SUM_25000"
}

export const GravestoneInsuranceSumDropDown: DropDownModel[] = [
    {
        id: GravestoneInsuranceSumId.fiveThousands,
        displayName: "5 000 zł"
    },
    {
        id: GravestoneInsuranceSumId.tenThousands,
        displayName: "10 000 zł"
    },
    {
        id: GravestoneInsuranceSumId.fifteenThousands,
        displayName: "15 000 zł"
    },
    {
        id: GravestoneInsuranceSumId.twentyFiveThousands,
        displayName: "25 000 zł"
    }
];
